import React from "react";
import {LabeledValue} from "antd/lib/select";
import ReinsurerBrokerMultiSelect from "../../select/MultiSelect/ReinsurerBrokerMultiSelect";
import FilterContainer from "./FilterContainer";
import {FilterDropdownProps} from "antd/lib/table/interface";
import {DELAY_TIMER_SEARCH_FILTER, endAndStartTimerFilter} from "./columnsUtils";

export default function ReinsurerBrokerFilter(props: FilterDropdownProps) {

    return <FilterContainer {...props}>
        <ReinsurerBrokerMultiSelect
            style={{width: '20rem'}}
            onChange={(values: LabeledValue[]) => {
                // @ts-ignore
                props.setSelectedKeys(values.reverse().map(el => ({label: el.label, value: el.value})))
                endAndStartTimerFilter(props.confirm, DELAY_TIMER_SEARCH_FILTER)
            }}
            value={props.selectedKeys}
        />
        </FilterContainer>

}